/**
 * Role names now live in `@neogeniux/api-contracts` so neoapi's guards
 * and neocrm share ONE definition. Re-exported under the historical
 * `Roles` name — the values are identical, so every existing
 * `Roles.Admin` / `Roles.SuperAdmin` call site is unchanged.
 */
import { RoleName } from '@neogeniux/api-contracts';

export const Roles = {
  SuperAdmin: RoleName.SUPER_ADMIN,
  Admin: RoleName.ADMIN,
  Manager: RoleName.MANAGER,
  Cashier: RoleName.CASHIER,
} as const;

export type Roles = (typeof Roles)[keyof typeof Roles];
